import { useState } from 'react';
import { t } from '@lingui/macro';

import Pencil from '@decisiv/iconix/lib/components/Pencil';

import Button from '@decisiv/ui-components/lib/components/Button';

import FleetAdminAction from 'components/FleetAdminAction';
import useFleetAdminPermissions from 'utils/User/useFleetAdminPermissions';

import type { ManagedFleet } from '../..';
import EditAccountModal from '../../EditAccountModal';

interface ActionCellProps {
  rowData: ManagedFleet;
}

const ActionsCell = ({ rowData: platformAccount }: ActionCellProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const fleetAdminPermissions = useFleetAdminPermissions();
  const editCapability = fleetAdminPermissions.capability(
    platformAccount.sentinelTeam?.oemSegment?.id,
    'canEditAccount',
  );

  const handleActionClick = () => {
    setModalVisible(true);
  };

  return (
    <>
      <FleetAdminAction capability={editCapability}>
        {({ disabled }) => (
          <Button
            text={t`Edit`}
            icon={Pencil}
            kind="secondary"
            size="small"
            disabled={disabled}
            onClick={handleActionClick}
          />
        )}
      </FleetAdminAction>
      {modalVisible && (
        <EditAccountModal
          visible
          onClose={
            /* istanbul ignore next -- @preserve */
            () => setModalVisible(false)
          }
          platformAccount={platformAccount}
        />
      )}
    </>
  );
};

export default ActionsCell;
